import { type ClientConfig, type InputDataType } from './workflows';
import { Comparison } from 'vince-core/types/common';

export const enum TriggerType {
    CLIENT = 'CLIENT',
    SCHEDULE = 'SCHEDULE',
    EVENT = 'EVENT'
}

export interface TriggerStepDefinition {
    triggerType: TriggerType;
}

export enum FormFieldType {
    TEXT = 'text',
    DATE = 'date',
    BROWSE = 'browse', // TODO Should be removed
    TAG = 'tag'
}

export interface FormField {
    formGroupId?: number;
    elementPosition: number;

    fieldId: string;
    apiId?: string;
    fieldName: string;
    dataType: InputDataType;

    type: FormFieldType;
    label: string;
    placeHolder: string;
    tooltip?: string;
    valueNotRequired?: boolean;
    length: string;
    mandatory: boolean;
    value?: string | number;
    customRequired?: boolean;
}

export interface FormGroup {
    groupId: number;
    groupName: string;
}

export interface LookupConfig {
    tenantId?: string;
    workflowName: string;
    workflowId: string;
    lookupName: string;
    outputMap?: Record<string, string>
    inputMap?: Record<string, string>
}


export interface ClientTrigger extends TriggerStepDefinition, ClientConfig {
    availableFields?: FormField[]; // fields that user will be able to manipulate
    tags?: Record<string, string>,
}

export interface ScheduleTrigger extends TriggerStepDefinition {
    timezone: string;
    expression: string;
    autoTimezone: boolean;
    startTime?: string;
    startDate?: string;
    endTime?: string;
    endDate?: string;
    scheduleId?: string;
    cleared?: boolean;
}

export interface EventTriggerActions {
    create: boolean;
    delete: boolean;
    update: boolean;
}

export const enum EventTriggerPathPrefix {
    NEW_DATA = 'newData',
    OLD_DATA = 'oldData',
    CHANGED = 'changed'
}

export interface EventTriggerRule {
    path: string | null;
    fact: 'data';
    value: string | null;
    operator: Comparison;
}

export interface EventTrigger extends TriggerStepDefinition {
    // TODO MOVE TO BACKED!!!!
    filter: unknown;
    eventType: 'TABLE';
    columns: string[];
    actions: EventTriggerActions;
    tableName: string | null;
    rules: EventTriggerRule[];
    expression?: string;
    type?: string;
}
